import React from 'react'
import Footer from '../Footer'
import EducationCLRHS2 from '../EducationCLRHS2'

function CLRHS2() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS2/>
            <Footer/>
        </div>
    )
}

export default CLRHS2
